/**
 * Public SEO landing pages ("guides"). Each maps its path to its key in the
 * `guides` translation namespace, which holds the copy for the page, the
 * server-rendered HTML, the FAQ JSON-LD and llms.txt.
 */
export const GUIDE_PAGES = {
  "/email-alias": "emailAlias",
  "/catch-all-email": "catchAll",
} as const;

type GuidePath = keyof typeof GUIDE_PAGES;
export type GuideKey = (typeof GUIDE_PAGES)[GuidePath];

export const GUIDE_PATHS = Object.keys(GUIDE_PAGES) as GuidePath[];
